var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBugScreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150",
      fill: "#2281ff"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.8,60.8v12.1H75h16.2V60.8H75H58.8z M58.8,84.3v12.1H75h16.2V84.3H75H58.8z M133.8,10.2H16.2c-3.3,0-6,2.7-6,6v117.5 c0,3.3,2.7,6,6,6h117.5c3.3,0,6-2.7,6-6V16.2C139.8,12.9,137.1,10.2,133.8,10.2z M123.8,66.3h-11.9c0.4,2.2,0.7,4.5,0.9,6.8h11v11 h-11c-0.2,2.3-0.5,4.6-0.9,6.8h11.9v11H109c-6.3,17-19.1,28.7-34,28.7c-14.9,0-27.7-11.7-34-28.7H26.2v-11h11.9 c-0.4-2.2-0.7-4.5-0.9-6.8h-11v-11h11c0.2-2.3,0.5-4.6,0.9-6.8H26.2v-11H41c2.3-6.2,5.5-11.8,9.3-16.2L39.7,26.5l8.4-7.1 l10.5,12.4c5-3.3,10.5-5.2,16.4-5.2s11.5,1.9,16.4,5.2l10.5-12.4l8.4,7.1L99.7,39.1c3.8,4.5,7,10,9.3,16.2h14.9V66.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugScreenIcon);
export default __webpack_public_path__ + "static/media/BugScreenIcon.cf9866556fcbadd9ebc901dcaad46726.svg";
export { ForwardRef as ReactComponent };